module.exports = __webpack_public_path__ + "img/gtm-doc.8219c14e.jpg";